import { styled } from 'styled-components';
import { IconButton } from '../common';
import { INITIAL_TRANSLATE, INITIAL_ZOOM } from './ImageViewer';

type ViewerControlsProps = {
    onImageInGrayScale: (isGrayScale: boolean) => void;
    rotationDegrees: number;
    setRotationDegrees: (degrees: number) => void;
    setTranslate: (translate: typeof INITIAL_TRANSLATE) => void;
    setZoomLevel: (zoomLevel: number) => void;
    showGrayScaleControls: boolean;
    zoomLevel: number;
};

const colorWheelButtons = [
    { className: 'image-color', greyScale: false, icon: 'color-wheel' },
    { className: 'image-gray', greyScale: true, icon: 'color-wheel-bw' },
];

const ZOOM_FACTOR = 1.6;
const ROTATION_STEP = 90;

export function ViewerControls({
    rotationDegrees,
    onImageInGrayScale,
    setRotationDegrees,
    setTranslate,
    setZoomLevel,
    showGrayScaleControls,
    zoomLevel,
}: ViewerControlsProps) {
    const onZoomIn = () => {
        setZoomLevel(zoomLevel * ZOOM_FACTOR);
    };
    const onZoomOut = () => {
        setZoomLevel(zoomLevel * (1 / ZOOM_FACTOR));
    };
    const onZoomReset = () => {
        setZoomLevel(INITIAL_ZOOM);
        setTranslate(INITIAL_TRANSLATE);
    };
    const onRotateLeft = () => {
        setRotationDegrees(rotationDegrees - ROTATION_STEP);
    };
    const onRotateRight = () => {
        setRotationDegrees(rotationDegrees + ROTATION_STEP);
    };

    return (
        <StyledViewerControls>
            {showGrayScaleControls && (
                <StyledButtonGroup>
                    {colorWheelButtons.map((button, index) => (
                        <IconButton
                            className={button.className}
                            icon={button.icon}
                            key={index}
                            onClick={() => {
                                onImageInGrayScale(button.greyScale);
                            }}
                        ></IconButton>
                    ))}
                </StyledButtonGroup>
            )}
            <StyledButtonGroup>
                <IconButton
                    icon="zoom-out"
                    onClick={onZoomOut}
                />
                <IconButton
                    icon="zoom-reset"
                    onClick={onZoomReset}
                />
                <IconButton
                    icon="zoom-in"
                    onClick={onZoomIn}
                />
            </StyledButtonGroup>
            <StyledButtonGroup>
                <IconButton
                    icon="rotate-left"
                    onClick={onRotateLeft}
                />
                <IconButton
                    icon="rotate-right"
                    onClick={onRotateRight}
                />
            </StyledButtonGroup>
        </StyledViewerControls>
    );
}

const StyledViewerControls = styled.div`
    position: absolute;
    width: 100%;
    bottom: 20px;
    z-index: 9999;
    align-items: center;
    display: flex;
    justify-content: center;
`;

const StyledButtonGroup = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 0 20px;
`;
